export var ThirdPartyAuthenticationService;
(function (ThirdPartyAuthenticationService) {
    ThirdPartyAuthenticationService[ThirdPartyAuthenticationService["AutoLogin"] = 0] = "AutoLogin";
    ThirdPartyAuthenticationService[ThirdPartyAuthenticationService["LoginButton"] = 1] = "LoginButton";
    ThirdPartyAuthenticationService[ThirdPartyAuthenticationService["LoginLink"] = 2] = "LoginLink";
    ThirdPartyAuthenticationService[ThirdPartyAuthenticationService["LoginToken"] = 3] = "LoginToken";
    ThirdPartyAuthenticationService[ThirdPartyAuthenticationService["CertificateLogin"] = 4] = "CertificateLogin";
    ThirdPartyAuthenticationService[ThirdPartyAuthenticationService["Trading"] = 5] = "Trading";
})(ThirdPartyAuthenticationService || (ThirdPartyAuthenticationService = {}));
export function getService(serviceType, service) {
    if (isNullOrUndefined(service)) {
        return null;
    }
    const typedService = service;
    switch (serviceType) {
        case ThirdPartyAuthenticationService.AutoLogin:
            return isProdiveAutoLoginService(service) ? typedService : null;
        case ThirdPartyAuthenticationService.LoginButton:
            return isProdiveLoginButtonService(service) ? typedService : null;
        case ThirdPartyAuthenticationService.LoginLink:
            return isProvideLoginLinkService(service) ? typedService : null;
        case ThirdPartyAuthenticationService.LoginToken:
            return isProdiveLoginTokenService(service) ? typedService : null;
        case ThirdPartyAuthenticationService.CertificateLogin:
            return isProdiveCertificateLoginService(service) ? typedService : null;
        case ThirdPartyAuthenticationService.Trading:
            return isProdiveTradingService(service) ? typedService : null;
        default:
            return null;
    }
}
// #endregion
// #region Helper functions
function isProdiveAutoLoginService(service) {
    if (isNullOrUndefined(service)) {
        return false;
    }
    return 'processAutoLogin' in service;
}
function isProdiveLoginButtonService(service) {
    if (isNullOrUndefined(service)) {
        return false;
    }
    return 'buttonText' in service && 'processLogin' in service;
}
function isProvideLoginLinkService(service) {
    if (isNullOrUndefined(service)) {
        return false;
    }
    return 'loginLinkText' in service && 'processLoginLink' in service;
}
function isProdiveLoginTokenService(service) {
    if (isNullOrUndefined(service)) {
        return false;
    }
    return ('isInputMode' in service &&
        'processToken' in service &&
        'processConnectionData' in service &&
        'processLoginRejection' in service);
}
function isProdiveCertificateLoginService(service) {
    if (isNullOrUndefined(service)) {
        return false;
    }
    return ('certificateLinkText' in service &&
        'showCertificate' in service &&
        'checkCertificate' in service &&
        'deleteCertificate' in service);
}
function isProdiveTradingService(service) {
    if (isNullOrUndefined(service)) {
        return false;
    }
    return 'isAllowTrading' in service;
}
// #endregion
